import { mineActions } from '$store/mine';
import { store } from '$store/store';

let lastSendAt = 0;
let hasAccess = false;
const SHAKE_THRESHOLD = 15;
let animationId = 0;
let started = false;

let shakeLockAt = 0;

export function lockShake() {
  shakeLockAt = Date.now();
}

function onShakeDetected() {
  if (navigator.vibrate) {
    navigator.vibrate(50);
  }

  store.dispatch(mineActions.shake());
}

function handleMotionEvent(event) {
  vx += event.acceleration.x;
  vy += event.acceleration.y;

  hasAccess = true;

  if (!started) {
    return;
  }

  const acceleration = event.accelerationIncludingGravity;
  const shakeMagnitude = Math.sqrt(
    acceleration.x * acceleration.x +
      acceleration.y * acceleration.y +
      acceleration.z * acceleration.z,
  );

  if (shakeMagnitude > SHAKE_THRESHOLD && Date.now() - shakeLockAt > 1000) {
    const now = Date.now();
    if (now - lastSendAt > 400) {
      lastSendAt = now;
      onShakeDetected();
    }
  }
}

export function startShakeDetection() {
  if (window.DeviceMotionEvent) {
    window.addEventListener('devicemotion', handleMotionEvent, {
      capture: true,
      passive: false,
    });

    started = true;
    startShakeAnimation();
  } else {
    console.log('DeviceMotionEvent не поддерживается');
  }
}

export function stopShakeDetection() {
  window.removeEventListener('devicemotion', handleMotionEvent, {
    capture: true,
    // @ts-ignore
    passive: false,
  });
  started = false;
  cancelAnimationFrame(animationId);
}

export function checkShakeAccess() {
  return hasAccess;
}

// Animation
let x = 0;
let y = 0;
let vx = 0; // Скорость по X
let vy = 0; // Скорость по Y
const damping = 0.9; // Демпфирование
const spring = 0.7; // Жёсткость пружины
const mass = 15; // Масса
let circle: any = null;

const interpolate = (value, min, max) => {
  const range = max - min;
  const threshold = 0.1 * range; // 10% от диапазона
  if (value < min + threshold) {
    return min + Math.sin(((value - min) / threshold) * (Math.PI / 2)) * threshold;
  } else if (value > max - threshold) {
    return max - Math.sin(((max - value) / threshold) * (Math.PI / 2)) * threshold;
  } else {
    return value;
  }
};

function animate() {
  if (!circle || !started) {
    return;
  }

  // Вычисление силы пружины
  let fx = -spring * x;
  let fy = -spring * y;

  // Ускорение = Сила / масса
  let ax = fx / mass;
  let ay = fy / mass;

  // Изменение скорости
  vx = vx + ax;
  vy = vy + ay;

  // Демпфирование
  vx *= damping;
  vy *= damping;

  // Обновление позиции
  x += vx;
  y += vy;

  // Ограничение движения с замедлением у границ
  const rangeX = [-150, 150];
  const rangeY = [-150, 150];
  const mX = interpolate(x, rangeX[0], rangeX[1]);
  const mY = interpolate(y, rangeY[0], rangeY[1]);

  // Применение трансформации к элементу
  const scaleX = 1 + Math.min(Math.abs(vx) / 50, 0.1);
  const scaleY = 1 + Math.min(Math.abs(vy) / 50, 0.1);
  circle.style.transform = `translate(${mX / 4}px, ${
    mY / 2
  }px) scale(${scaleX}, ${scaleY})`;

  animationId = requestAnimationFrame(animate);
}

function startShakeAnimation() {
  circle = document.getElementById('shake_button');
  if (circle) {
    animate();
  }
}

window.addEventListener('devicemotion', () => {
  hasAccess = true;
});
